/* eslint-disable max-classes-per-file */
import { Uuid } from '@ftr/contracts/type/shared'
import { RealTimePlaybackKey } from '@ftr/data-realtime-playback'
import { SttEditTransaction } from '@ftr/regional-api-contracts'
import { LocalTime, ZonedDateTime } from '@js-joda/core'
import { HearingSectionFormModel, SessionJudgesChangedEvent } from '../../lib'
import { RealTimeSttMarkerEditSource } from '../../types'
import { SttEditOperation } from './edit-operations'
import { ValidationErrorResult } from './edit-operations/operation-result'

export class RealTimeSttHearingUpdatedEvent {
  static readonly type = '[RealTimeStt] Hearing updated'

  constructor(
    readonly playbackKey: RealTimePlaybackKey,
    readonly hearingSectionId: Uuid,
    readonly hearingSection: HearingSectionFormModel,
  ) {}
}

export class RealTimeSttHearingAcceptAutoGeneratedEvent {
  static readonly type = '[RealTimeStt] Hearing accept auto generated'

  constructor(
    readonly playbackKey: RealTimePlaybackKey,
    readonly hearingSectionId: Uuid,
  ) {}
}

export class RealTimeSttHearingDeletedEvent {
  static readonly type = '[RealTimeStt] Hearing deleted'

  constructor(
    readonly playbackKey: RealTimePlaybackKey,
    readonly hearingSectionId: string,
    readonly source?: RealTimeSttMarkerEditSource,
  ) {}
}

export class RealTimeSttHearingSectionSetToOngoingEvent {
  static readonly type = '[RealTimeStt] Hearing Section set to ongoing'

  constructor(
    readonly playbackKey: RealTimePlaybackKey,
    readonly hearingSectionId: string,
  ) {}
}
export class RealTimeSttTimeSelectedEvent {
  static readonly type = '[RealTimeStt] Select Remark Time'

  constructor(
    readonly playbackKey: RealTimePlaybackKey,
    readonly remarkTime: LocalTime,
    readonly shouldPlay: boolean,
  ) {}
}

export class RealTimeSttSessionModifiedEvent {
  static readonly type = '[RealTimeStt] Session Modified'

  constructor(
    readonly playbackKey: RealTimePlaybackKey,
    readonly courtroomSessionId: Uuid,
    readonly departmentId: Uuid | undefined,
    readonly markerId: string,
    readonly startTime: string,
    readonly endTime: string,
    readonly source?: RealTimeSttMarkerEditSource,
  ) {}
}

export class RealTimeSttSessionJudgesModifiedEvent {
  static readonly type = '[RealTimeStt] Session Judges Modified'

  constructor(
    readonly playbackKey: RealTimePlaybackKey,
    readonly event: SessionJudgesChangedEvent,
  ) {}
}

export class RealTimeSttSealingModifiedEvent {
  static readonly type = '[RealTimeStt] Sealing Modified'

  constructor(
    readonly playbackKey: RealTimePlaybackKey,
    readonly markerId: string,
    readonly startTime: string,
    readonly endTime: string,
    readonly source?: RealTimeSttMarkerEditSource,
  ) {}
}

export class RealTimeSttSegmentMapReinitializedEvent {
  static readonly type = '[RealTimeStt] SegmentMap reinitialized'

  constructor(readonly playbackKey: RealTimePlaybackKey) {}
}

export class PersistSttEditTransactionBeganEvent {
  static readonly type = '[RealTimeStt] Persist of Realtime STT Edit began'

  constructor(
    readonly playbackKey: RealTimePlaybackKey,
    readonly transaction: SttEditTransaction,
    readonly courtSystemId: Uuid,
  ) {}
}

export class PersistSttEditTransactionSucceededEvent {
  static readonly type = '[RealTimeStt] Persist of Realtime STT Edit succeeded'

  constructor(
    readonly playbackKey: RealTimePlaybackKey,
    readonly transaction: SttEditTransaction,
    readonly courtSystemId: Uuid,
  ) {}
}

export class PersistSttEditTransactionFailedEvent {
  static readonly type = '[RealTimeStt] Persist of Realtime STT Edit failed'

  constructor(
    readonly playbackKey: RealTimePlaybackKey,
    readonly transaction: SttEditTransaction,
    readonly courtSystemId: Uuid,
  ) {}
}

export class SttEditOperationSucceededEvent {
  static readonly type = '[RealTimeStt] SttEditOperation succeeded'

  constructor(
    readonly playbackKey: RealTimePlaybackKey,
    readonly operation: SttEditOperation,
    readonly affectedRemarkIds: Uuid[],
  ) {}
}

export class SttEditOperationSkippedEvent {
  static readonly type = '[RealTimeStt] SttEditOperation skipped'

  constructor(
    readonly playbackKey: RealTimePlaybackKey,
    readonly operation: SttEditOperation,
    readonly reason: string,
  ) {}
}

export class SttEditOperationFailedEvent {
  static readonly type = '[RealTimeStt] SttEditOperation failed'

  constructor(
    readonly playbackKey: RealTimePlaybackKey,
    readonly operation: SttEditOperation,
    readonly validationError?: ValidationErrorResult,
  ) {}
}

export class RealTimeSttLastEditedUpdatedEvent {
  static readonly type = '[RealTimeStt] Last Edited Updated'

  constructor(
    readonly playbackKey: RealTimePlaybackKey,
    readonly lastEdited: ZonedDateTime | undefined,
  ) {}
}

export class RealTimeSttEditTransactionConflictEvent {
  static readonly type = '[RealTimeStt] Stt Edit Transaction Conflict'

  constructor(
    readonly playbackKey: RealTimePlaybackKey,
    readonly transaction: SttEditTransaction,
  ) {}
}
